import {reactive} from "vue";
import {store} from "@/store/store-decorators";
import {RootStore} from "@/store/RootStore";
import UIControlDetail from "@/domain/maintenance/ui/UIControlDetail";


type State = {
    newUIEnabled: boolean;
    appVersion: string;
    controls: Array<UIControlDetail>;
}

@store
export default class AppConfigStore {
    private rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    private state = reactive<State>({
        newUIEnabled: AppConfigStore.getSessionIsNewUIEnabled(),
        appVersion: AppConfigStore.getSessionVersion(),
        controls: []
    })


    private static getSessionIsNewUIEnabled(): boolean {
        const storedVal = sessionStorage.getItem("newUIEnabled");
        return storedVal? storedVal.toLowerCase() === "true" : false
    }

    public getNewUIEnabled() {
        return this.state.newUIEnabled;
    }

    public setNewUIEnabled(value: boolean) {
        this.state.newUIEnabled = value;
        sessionStorage.setItem("newUIEnabled", Boolean(value).toString());
    }

    public getVersion() {
        return this.state.appVersion;
    }

    public setSessionVersion(value: string) {
        this.state.appVersion = value;
        sessionStorage.setItem('appVersion', value);
    }

    private static getSessionVersion(): string {
        const storedVal = sessionStorage.getItem("appVersion");
        return storedVal? storedVal : '';
    }

    get controls(): Array<UIControlDetail> {
        return this.state.controls;
    }

    set controls(value: Array<UIControlDetail>) {
        this.state.controls = value;
    }

    public getControlLabelFromObjectProperty(propName: string): string {
        if (this.state.controls) {
            const control = this.state.controls.find(ctrl => ctrl.ctrlName === propName);
            return control ? control.ctrlLabel : propName;
        }
        return propName;
    }
}